import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-activity-type-dev-type',
  templateUrl: './activity-type-dev-type.component.html',
  styleUrls: ['./activity-type-dev-type.component.css']
})
export class ActivityTypeDevTypeComponent implements OnInit {
    activityTypeDevTypeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private state: StateService, private datatask: DataTaskService) {
        this.activityTypeDevTypeKeyno = this.state.getStateParams()['activitytypedevtype_keyno'];
    }

    private async loadEdit() {
        if (!!this.activityTypeDevTypeKeyno) {
            this.edit = (await this.datatask.Post(1236, { activitytypedevtype_keyno: this.activityTypeDevTypeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1237, this.edit);

                this.state.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    activitytypedevtype_keyno: string;
    activitytype_name: string;
    deviationtype_name: string;
    isactive: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeDevType', {
//        templateUrl: 'views/components/views/activityTypeDevType/activityTypeDevType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'activityTypeDevTypeService', function ($stateParams, stateService, activityTypeDevTypeService) {
//            const vm = this;
//            let activityTypeDevTypeKeyno = $stateParams.activitytypedevtype_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await activityTypeDevTypeService.getEdit({ activitytypedevtype_keyno: activityTypeDevTypeKeyno }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                activityTypeDevTypeService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            }
//        }]
//    });
//})();
